import { render } from "./NpsChart.vue?vue&type=template&id=c6f36d82"
import script from "./NpsChart.vue?vue&type=script&lang=js"
export * from "./NpsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__